<template>
  <div>
    <b-form>
      <b-form-group
          id="botKey-group"
          label="Бот-ключ"
          label-for="botKey"
      >
        <template
            #description
            v-if="botKeyLength > 0"
        >
          <div tabindex="-1">
            {{botKeyDescription}}
          </div>
        </template>
        <b-form-input
            id="botKey"
            placeholder="Введите бот-ключ пользователя"
            :value="form.botKey"
            :state="botKeyValidationStyle"
            @update="updateBotKey"
        />
      </b-form-group>


      <b-form-group id="role-group" label="Роль" label-for="role">
        <b-form-select
            id="role"
            :value="form.role"
            :options="roles"
            required
            @input="form = {...form, role: $event}"
        >
          <template
              #default
              v-if="!form.role"
          >
            <b-form-select-option :value="undefined" disabled>Роль не выбрана</b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>

      <b-form-group id="lng-group" label="Язык" label-for="lng">
        <b-form-select
            id="lng"
            :value="form.lng"
            :options="lngs"
            @input="form = {...form, lng: $event}"
            required
        >
          <template
              #default
              v-if="!form.lng"
          >
            <b-form-select-option :value="undefined" disabled>Язык не выбран</b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'AppEditUserForm',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      roles: [
        {text: 'Веб-мастер', value: 'publisher'},
        {text: 'Рекламодатель', value: 'advertiser'},
      ],
      lngs: [
        {text: 'ru', value: 'ru'},
        {text: 'en', value: 'en'},
      ],
      form: {},
      botKeyLength: 0,
    }
  },
  computed: {
    botKeyDescription () {
      return `Длина: ${this.botKeyLength}/32`
    },
    botKeyValidationStyle () {
      if (this.botKeyLength === 0) return null
      return this.botKeyLength === 32;

    },
  },
  watch: {
    user: {
      immediate: true,
      handler(newVal) {
        this.form = newVal
        if (newVal.botKey?.length) {
          this.botKeyLength = newVal.botKey?.length
        }
      },
    },
    form: {
      deep: true,
      handler (newVal) {
        this.$emit('updateUser', newVal)
      }
    }
  },
  methods: {
    updateBotKey(botKey) {
      this.form = {...this.form, botKey}
      this.botKeyLength = botKey.length
    },
  },
}
</script>
